/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import classNames from 'classnames';
import _get from 'lodash/get';
import * as Yup from 'yup';
import { Field, Form, Formik } from 'formik';
import formStyles from 'legacy/common/components/form/Form.module.scss';
import Modal, { ModalType } from 'legacy/common/components/modal/Modal';
import Button, { ButtonType } from 'legacy/common/components/button/Button';
import { TbAlertTriangleFilled } from 'react-icons/tb';

type LinkFormProps = {
  title?: string;
  onClose: () => void;
  onSubmit: ({ text, link }) => void;
};

const LinkForm: React.FC<LinkFormProps> = ({ title, onClose, onSubmit }) => (
  <Formik
    initialValues={{
      link: '',
      text: ''
    }}
    onSubmit={(values) => {
      onSubmit({
        text: values.text,
        link: values.link
      });
    }}
    validationSchema={Yup.object().shape({
      link: Yup.string().url().required('Link is required'),
      text: Yup.string().required('Text is required')
    })}
  >
    {({ errors, touched, submitForm }) => {
      const showLinkError = !!_get(errors, 'link') && !!_get(touched, 'link');
      const showTextError = !!_get(errors, 'text') && !!_get(touched, 'text');
      return (
        <Modal
          type={ModalType.SMALL}
          autoHeight
          onClose={onClose}
          visible
          icon={<img src="/img/icons/link.svg" className="w-6 h-6" />}
          title={title || 'Add link'}
          renderFooter={() => (
            <Button
              disabled={showLinkError || showTextError}
              type={ButtonType.Primary}
              onClick={submitForm}
            >
              Save URL
            </Button>
          )}
        >
          <Form className="h-full">
            <div className="p-4 pt-0 mt-4 flex flex-col justify-between">
              <h2 className="mt-2 text-sm font-normal text-gray-500">
                Add a link URL and display text
              </h2>

              <div className="mt-4">
                <label
                  htmlFor="code"
                  className="mt-2.5 mb-2.5 p-0 text-xs text-left text-gray-900 font-normal"
                >
                  Link URL
                </label>
                <Field
                  id="link"
                  name="link"
                  type="text"
                  maxLength={120}
                  required
                  className={classNames(
                    'w-full h-10 border border-gray-300 rounded-md px-4 text-base bg-white placeholder-opacity-40 placeholder-gray-800',
                    ((touched.link && errors?.link) || errors?.link) &&
                      formStyles.errorField
                  )}
                  placeholder="e.g. https://www.bouncelife.com/"
                  data-testId="display-name-input"
                />
                {showLinkError && (
                  <div className="mt-2 text-red-800 flex items-center gap-1 font-normal">
                    <TbAlertTriangleFilled size={16} /> {_get(errors, 'link')}
                  </div>
                )}
              </div>

              <div className="mt-4">
                <label
                  htmlFor="text"
                  className="mt-2.5 mb-2.5 p-0 text-xs text-left text-gray-900 font-normal"
                >
                  Display Text
                </label>
                <div className="relative">
                  <Field
                    id="text"
                    name="text"
                    maxLength={30}
                    type="text"
                    required
                    className={classNames(
                      'w-full h-10 border border-gray-300 rounded-md px-4 text-base bg-white placeholder-opacity-40 placeholder-gray-800',
                      ((touched.text && errors?.text) || errors?.link) &&
                        formStyles.errorField
                    )}
                    placeholder="e.g. privacy policy"
                    data-testId="code-input"
                  />
                </div>
                {showTextError && (
                  <div className="mt-2 text-red-800 flex items-center gap-1 font-normal">
                    <TbAlertTriangleFilled size={16} /> {_get(errors, 'text')}
                  </div>
                )}
              </div>
            </div>
          </Form>
        </Modal>
      );
    }}
  </Formik>
);

export default LinkForm;
